export default "__VITE_ASSET__BB0$akGa__"